import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAutenticacao } from "@/contextos/AutenticacaoContexto";
import { Trophy, Menu, LogOut, ShieldCheck, Target, BarChart3, Users, Settings, FileText, Newspaper, Wallet, ClipboardList } from "lucide-react";
import { useState } from "react";

const ITEMS_APOSTADOR = [
  { para: "/dashboard", icone: BarChart3, rotulo: "Visão Geral" },
  { para: "/palpitar", icone: Target, rotulo: "Palpitar" },
  { para: "/meus-palpites", icone: ClipboardList, rotulo: "Meus Palpites" },
  { para: "/ranking", icone: Trophy, rotulo: "Ranking" },
  { para: "/regulamento", icone: FileText, rotulo: "Regulamento" },
];

const ITEMS_ADMIN = [
  { para: "/admin", icone: BarChart3, rotulo: "Visão Geral" },
  { para: "/admin/jogos", icone: Target, rotulo: "Jogos & Resultados" },
  { para: "/admin/usuarios", icone: Users, rotulo: "Usuários" },
  { para: "/admin/pagamentos", icone: Wallet, rotulo: "Pagamentos" },
  { para: "/admin/informativos", icone: Newspaper, rotulo: "Informativos" },
  { para: "/admin/regulamento", icone: FileText, rotulo: "Regulamento", superAdminOnly: true },
  { para: "/admin/configuracoes", icone: Settings, rotulo: "Configurações" },
  { para: "/admin/logs", icone: ShieldCheck, rotulo: "Logs" },
];

export function LayoutAutenticado({ children }) {
  const { usuario, sair } = useAutenticacao();
  const navigate = useNavigate();
  const [aberto, setAberto] = useState(false);

  const isAdmin = usuario?.perfil === "ADMINISTRADOR" || usuario?.perfil === "SUPER_ADMIN";
  const itens = isAdmin ? ITEMS_ADMIN : ITEMS_APOSTADOR;

  const handleSair = async () => {
    await sair();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-superficie-base text-white flex">
      {/* Sidebar */}
      <aside
        className={`${aberto ? "translate-x-0" : "-translate-x-full"} md:translate-x-0 fixed md:sticky top-0 left-0 h-screen w-64 z-40 transition-transform bg-azulbrasil-dark border-r border-white/5 flex flex-col`}
      >
        <Link to="/" className="px-6 pt-6 pb-4 flex items-center gap-2 border-b border-white/5" data-testid="logo-sidebar">
          <div className="w-9 h-9 rounded-md bg-verdebrasil flex items-center justify-center">
            <Trophy className="w-5 h-5 text-amarelobrasil" />
          </div>
          <div>
            <div className="font-heading font-bold uppercase text-base leading-none">Bolão</div>
            <div className="text-[10px] tracking-[0.3em] text-amarelobrasil uppercase">Copa 2026</div>
          </div>
        </Link>
        <nav className="flex-1 p-4 space-y-1">
          {itens
            .filter((it) => !it.superAdminOnly || usuario?.perfil === "SUPER_ADMIN")
            .map((it) => (
            <NavLink
              key={it.para}
              to={it.para}
              data-testid={`nav-${it.para.replace(/\//g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-all ${
                  isActive
                    ? "bg-verdebrasil text-white"
                    : "text-white/70 hover:text-white hover:bg-white/5"
                }`
              }
              end={it.para === "/dashboard" || it.para === "/admin"}
              onClick={() => setAberto(false)}
            >
              <it.icone className="w-4 h-4" />
              {it.rotulo}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/5">
          <div className="px-3 py-2 mb-2 text-xs">
            <div className="font-bold truncate text-white" data-testid="user-name">{usuario?.nomeCompleto}</div>
            <div className="text-amarelobrasil uppercase tracking-widest text-[10px] font-bold mt-1">
              {usuario?.perfil?.replace("_", " ")}
            </div>
          </div>
          <button
            onClick={handleSair}
            className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm text-white/70 hover:text-white hover:bg-white/5 transition-all"
            data-testid="btn-sair"
          >
            <LogOut className="w-4 h-4" /> Sair
          </button>
        </div>
      </aside>

      {/* Conteúdo */}
      <main className="flex-1 min-w-0 md:ml-0">
        <header className="sticky top-0 z-30 bg-superficie-base/85 backdrop-blur-xl border-b border-white/5 px-4 md:px-8 py-3 flex items-center justify-between">
          <button
            className="md:hidden p-2 rounded-md hover:bg-white/5"
            onClick={() => setAberto((v) => !v)}
            data-testid="btn-toggle-menu"
          >
            <Menu className="w-5 h-5" />
          </button>
          <div className="font-heading uppercase tracking-[0.25em] text-xs text-white/60">
            Bolão Copa do Mundo FIFA 2026
          </div>
          <div className="hidden md:block text-xs text-white/60">
            Olá, <span className="text-white font-bold">{usuario?.nomePublico || usuario?.nomeCompleto?.split(" ")[0]}</span>
          </div>
        </header>
        <div className="p-4 md:p-8">{children}</div>
      </main>
    </div>
  );
}
